import React, { useEffect, useState, useRef } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core';
import { RequestPayOnline, UpdateMSBPayOnlineResponse } from '../billingservice';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import DefaultSettings from '../../core/controls/components/settings';
import { getEnvVariable } from '../../modules/environmentalList';

const MSBCheckout = (props) => {
    const { invoice, open, setOpen } = props;
    //const [isOpen, setIsOpen] = useState(open || false);
    const scriptLoadedRef = useRef(false);
    const [paymentRequestContext, setPaymentRequestContext] = useState(null);
    const [paymentResponse, setPaymentResponse] = useState(null);
    const prevInvoiceRef = useRef();

    useEffect(() => {
        prevInvoiceRef.current = invoice;
    });

    useEffect(() => {
        const prevInvoice = prevInvoiceRef.current;
        if (open && !scriptLoadedRef.current && !paymentRequestContext) {
            const script = document.createElement('script');
            script.src = getEnvVariable("MSBIntegratorURL") || " https://staging.payments.msbpay.com/msbpay.js";
            script.async = true;
            scriptLoadedRef.current = true;
            script.onload = () => {               
                prepareForPayment();          
            };
            script.onerror = () => {
                console.error('Failed to load MSBPay script-----');
            };
            document.body.appendChild(script);
            return () => {
                document.body.removeChild(script);
            };
        } 
    }, [open, invoice]);

    const prepareForPayment = async () => {
        let invid = invoice?.Id || 5;
        if (!invoice ) {
            if (DefaultSettings.getAlert() != null){
                DefaultSettings.getAlert().show(`Loading test invoice data. PLEASE CORRECT FOR PASSING INVOICE INFORMATOIN`, 'error');
            }
        }
        RequestPayOnline(invid).then(res => {
            if(res && res.context && res.key){
                setPaymentRequestContext(res);
                if (window.msbpay) {
                    window.msbpay.checkout('checkout-form', res, paymentCallback)                   
                }else{
                    if (DefaultSettings.getAlert() != null){
                        DefaultSettings.getAlert().show(`Unable to process your request. Contact administrator.`, 'error');
                    }
                    console.log('MSBPay library not loaded');
                }
            }
        })   
    };

    const handleClose = () => {
        if(setOpen)
        setOpen(false);        
    };

    const paymentCallback = (response) => {
        const jsonResponse = JSON.parse(response);
        const responseStatus = jsonResponse.Response;
        const message = jsonResponse.Message;
        const uniqueId = jsonResponse.ID;            
        console.log('Payment response:', jsonResponse,'Payment message:', message, 'Unique ID:', uniqueId);        
        if(paymentResponse !== uniqueId ){
            setPaymentResponse(uniqueId);
            if (DefaultSettings.getAlert() != null){
                DefaultSettings.getAlert().show('Payment processed successfully. Close the payment window', 'success');
                //DefaultSettings.getAlert().show(`Payment processed successfully! Reference Number-${uniqueId}`, 'success');
            }
            UpdateMSBPayOnlineResponse(uniqueId).then(res => {
                console.log('Payment response:', res);                
            })  
        }
                 
    }

    return (
        <Dialog open={open} maxWidth="sm" fullWidth>
        <DialogTitle disableTypography>
            <Typography variant="h6">Welcome to the online payment page</Typography>
            <IconButton aria-label="close" onClick={handleClose} style={{ position: 'absolute', right: 8, top: 8 }}>
                <CloseIcon />
            </IconButton>
        </DialogTitle>
        <DialogContent>
            <div id="checkout-form" style={{ top: '100px', width: '100%', height: '600px', border:'4px solid #673ab7' }}></div>
        </DialogContent>
        <DialogActions>         
        </DialogActions>
    </Dialog>
    );
};

export default MSBCheckout;